<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParam" :model="pageParam" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001207')" prop="addressName">
              <Input :placeholder="$t('key1002636')" clearable v-model.trim="pageParam.addressName"></Input>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box flex align-items-center justify-content-between">
      <div class="flex align-items-center">
        <Button
          class="mr15"
          type="primary"
          v-if="getPermission('ymsAddressTemplate_insert')"
          @click="$refs['addressLibrary'].initAddressLibraryData('add')">
          {{ $t('key1002637') }}
        </Button>
      </div>
      <div class="flex align-items-center">
        <!--自定义列-->
        <Button @click="$refs['customColumns'].initCustomColumnsData()">{{ $t('key1000977') }}</Button>
      </div>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tbableDom"
        highlight-row
        border
        max-height="580"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-sort-change="sortChange">
      </Table>
    </div>
    <!--新增地址模板弹窗-->
    <addressLibraryModal
      ref="addressLibrary"
      :countrysOriginalData="countrysOriginalData"
      @updateData="pageParamsStatus = true">
    </addressLibraryModal>
    <!--自定义列组件-->
    <customColumnsDrawer
      ref="customColumns"
      customColumnsKey="itemAttributesColumns"
      :originalColumns="originalColumns"
      :defaultSelectKeyList="defaultSelectKeyList"
      @customColumnsData="customColumnsData">
    </customColumnsDrawer>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import customColumnsDrawer from "@/components/common/customColumnsDrawer";
import addressLibraryModal from "@/views/yms/components/basicSettings/addressLibraryModal";
import {getAllCountrysData} from "@/utils/common";

export default {
  name: "addressLibraryManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParam: {
        addressName: '',
        orderBy: 'createdTime',
        status: null,
        servicePlatform: 'core',
        upDown: 'down'
      },
      tableColumns: [],
      originalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002628'),
          key: 'addressName',
          minWidth: 170,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002331'),
          key: 'name',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002332'),
          key: 'countryCode',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let text = '';
            let countryCode = params.row.countryCode;
            if (v.countrysOriginalData.length > 0) {
              v.countrysOriginalData.map((item) => {
                if (item.twoCode === countryCode) {
                  text = item.cnName;
                }
              });
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002333'),
          key: 'state',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002334'),
          key: 'city',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002335'),
          key: 'district',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002336'),
          key: 'street',
          minWidth: 150,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002337'),
          key: 'street2',
          minWidth: 150,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002338'),
          key: 'street3',
          minWidth: 150,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002340'),
          key: 'postcode',
          minWidth: 100,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002629'),
          key: 'phone',
          minWidth: 130,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002342'),
          key: 'email',
          minWidth: 160,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002341'),
          key: 'company',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          minWidth: 170,
          align: 'left',
          sortable: 'custom',
          sortType: 'desc',
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          minWidth: 100,
          align: 'left',
          render(h, params) {
            let status = params.row.status;
            let text = '';
            let statusList = [
              {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002630'),},
              {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631')}
            ];
            statusList.map((item) => {
              if (item.value === status) {
                text = item.name;
              }
            });
            return h('span', {class: status === 1 ? 'openStatus' : 'stopStatus'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          width: 200,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            let status = params.row.status;
            let ymsAddressTemplateId = params.row.ymsAddressTemplateId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['addressLibrary'].initAddressLibraryData('look', ymsAddressTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsAddressTemplate_update'),
                    clickFn: () => {
                      v.$refs['addressLibrary'].initAddressLibraryData('edit', ymsAddressTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsAddressTemplate_disable') && v.originalData.length > 1,
                    clickFn: () => {
                      v.enableDisableBtn('disable', ymsAddressTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsAddressTemplate_enable'),
                    clickFn: () => {
                      v.enableDisableBtn('enable', ymsAddressTemplateId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      defaultSelectKeyList: ['addressName', 'options'],
      setColumnsList: [],
      countrysOriginalData: [],
      originalData: [],
    };
  },
  created() {
    this.handleColumns();
    this.handleParam();
    getAllCountrysData().then((data) => {
      this.countrysOriginalData = data;
      this.getList('original');
    });
  },
  methods: {
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParam'].resetFields();
      v.getList();
    },
    // 查询按钮
    search() {
      this.pageParamsStatus = true;
    },
    // 获取列表数据
    getList(val) {
      let v = this;
      v.tableData = [];
      if (v.getPermission('ymsAddressTemplate_queryList')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsAddressTemplate_queryList, v.pageParam).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            v.tableData = data;
            if (val === 'original') {
              v.originalData = data.filter((item) => {
                return item.status === 1;
              });
            }
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 创建时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParam.upDown = obj[data.order];
      this.pageParam.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 启用、停用地址模板
    enableDisableBtn(type, ymsAddressTemplateId) {
      const v = this;
      const isDisable = (type === 'disable');
      const title = isDisable ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002632') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002633');
      const contentMsg = isDisable ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002634') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002635');
      const requestFn = () => {
        if (isDisable) {
          return v.axios.post(api.post_ymsAddressTemplate_disable, {
            stopUsingYmsAddressTemplateId: ymsAddressTemplateId
          }, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
        } else {
          return v.axios.put(api.put_ymsAddressTemplate_enable + ymsAddressTemplateId, {}, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
        }
      };
      v.$Modal.confirm({
        title,
        content: contentMsg,
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          requestFn().then(response => {
            if (response.data.code === 0) {
              v.$Message.success(isDisable ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel() {
        }
      });
    },
    // 处理列表字段
    handleColumns(data) {
      let v = this;
      v.optionBtnWidth = [];
      let sortKeyList = data || v.setColumnsList;
      let list = v.handleCustomColumnsSort(sortKeyList, [], v.originalColumns, v.defaultSelectKeyList);
      if (list.length > 0) {
        v.tableColumns = list;
      } else {
        let hideKeyColumns = [];
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyColumns.includes(item.key);
        });
      }
      v.updateTableDom('tbableDom');
    },
    // 获取当前列表设置展示的字段
    customColumnsData(data) {
      this.setColumnsList = data;
      this.handleColumns(data);
    },
    // 处理从其他入口新增地址模板
    handleParam() {
      let v = this;
      v.$nextTick(() => {
        let query = v.$route.query;
        if (query && query.addressLibraryType === 'add') {
          v.$refs['addressLibrary'].initAddressLibraryData('add');
          setTimeout(() => {
            let newUrl = window.location.href.split('?addressLibraryType')[0];
            window.history.replaceState({}, document.title, newUrl);
          }, 1000);
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    customColumnsDrawer,
    addressLibraryModal
  }
};
</script>

<style lang="less" scoped>

</style>